import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'product_tile-swatch_image-action_category_click';

/**
 * Click event for the swatch images on the product tile
 */
export function trackProductTileSwatchImageActionCategoryClick(
  context_string: string,
  requestId_string2: string,
  productToken: string,
  productOptionToken: string,
  index_string3: string,
  promotedBy_string4: string,
  impressionId_string5: string,
  screenContext_string6: string,
  containerContext_string7: string,
  token_string8: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      context_string,
      requestId_string2,
      productToken,
      productOptionToken,
      index_string3,
      promotedBy_string4,
      impressionId_string5,
      screenContext_string6,
      containerContext_string7,
      token_string8,
    },
  });
}
